<template>
  <v-container background fluid pa-2>
    <v-layout row wrap pa-3 style="background-color: #fff; margin: 10px; border-radius: 5px">
      <v-flex md12 sm12 xs12 ma-2>
        <v-layout row wrap>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="Branch_List"
              label="สาขา"
              item-text="name"
              item-value="code"
              v-model="branchSelect"
              hide-details
              :rules="form_rules.branch"
              required
              @input="selectbranch()"
              style="margin-bottom: 15px"
            />
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="Department_List"
              label="แผนก"
              item-text="name"
              item-value="code"
              v-model="departmentSelect"
              hide-details
              @input="selectbranch()"
              style="margin-bottom: 15px"
            />
          </v-flex>
          <v-flex md4 xs12 px-1>
            <v-select
              :items="Position_List"
              label="ฝ่าย"
              item-text="name"
              item-value="code"
              v-model="positionSelect"
              hide-details
              @input="selectbranch()"
              style="margin-bottom: 15px"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-container
            fluid
            pt-3
            style="
              border-right: 0px;
              border-left: 0px;
              padding-right: 0px;
              padding-bottom: 0px;
              padding-left: 0px;
            "
          >
            <v-layout row wrap v-for="(item, i) in listleave" :key="i">
              <v-flex md12 sm12 xs12 class="hidden-sm-and-up">
                <!-- ไม่แสดงขนาดกลางและขนาดใหญ๋ -->
                <v-expansion-panel expand>
                  <v-expansion-panel-content style="background-color: #ffffff; margin: 0px" expand-icon>
                    <div slot="header">
                      <v-card class="coco-box-shadow">
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg9 md9 sm8 xs12>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                <span class="coco-list-label-text content">{{ item.code }} :</span>
                                <span>{{ item.name }}</span>
                                <span style="margin-left: 10px; font-weight: bold">{{ item.department }}</span>
                              </v-flex>

                              <v-flex xs5 class="hidden-sm-and-up">
                                <br />
                                <span class="coco-list-label-text content">{{ item.code }} :</span>
                              </v-flex>
                              <v-flex xs7 class="hidden-sm-and-up">
                                <br />
                                <span>{{ item.name }}</span>
                              </v-flex>

                              <v-flex xs5 class="hidden-sm-and-up">
                                <span class="coco-list-label-text content">{{ $t("Position") }} :</span>
                              </v-flex>
                              <v-flex xs7 class="hidden-sm-and-up">
                                <span>{{ item.department }}</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md2 sm2 xs12 text-xs-right pa-3>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span>
                                  <strong>
                                    <h3 v-bind:style="[item.year_leave != null ? { color: 'green' } : { color: 'red' }]">
                                      {{ item.year_leave != null ? "ปี" + item.year_leave : "ไม่ได้ระบุปีการลา" }}
                                    </h3>
                                  </strong>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </div>
                    <v-card-text class="coco-box-shadow" style="overflow: auto">
                      <!-- detail hidden-sm-only -->
                      <v-flex md12 sm12 xs12>
                        <table>
                          <thead>
                            <tr>
                              <th nowrap width="20%" style="text-align: left">
                                ประเภทการลา
                              </th>
                              <th nowrap width="15%" style="text-align: center">
                                สิทธิ์การลา/ชม
                              </th>
                              <th nowrap width="15%" style="text-align: center">
                                จำนวนที่ใช้/ชม
                              </th>
                              <th nowrap width="15%" style="text-align: center">
                                ลาคงเหลือ/ชม
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <span>{{ $t("Personalleave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.personal_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.personal_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.personal_leave_hour - item.personal_leave_use }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>{{ $t("Ordinationleave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.ordination_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.ordination_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.ordination_leave_hour - item.ordination_leave_use }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>{{ $t("Vacationleave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.vacation_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.vacation_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.vacation_leave_hour - item.vacation_leave_use }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>{{ $t("Maternityleave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.maternity_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.maternity_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.maternity_leave_hour - item.maternity_leave_use }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>{{ $t("Sickleave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.sick_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.sick_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.sick_leave_hour - item.sick_leave_use }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>{{ $t("MilitaryServiceLeave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.military_service_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.military_service_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.military_service_leave_hour - item.military_service_leave_use }}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <span>{{ $t("Otherleave") }}</span>
                              </td>
                              <td>
                                <span style="color: green">{{ item.other_leave_hour }}</span>
                              </td>
                              <td>
                                <span>{{ item.other_leave_use }}</span>
                              </td>
                              <td>
                                <span style="color: red">{{ item.other_leave_hour - item.other_leave_use }}</span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <v-layout
                          row
                          wrap
                          v-for="(item, i) in typeleave"
                          :key="i"
                        >
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            class="coco-list-label-text hidden-sm-only"
                          >
                            <span style="font-weight: bold">{{
                              item.name
                            }}</span>
                           
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            class="coco-list-label-text hidden-sm-only"
                          >
                           
                            <span style="font-weight: bold">{{
                              item.name
                            }}</span>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            class="coco-list-label-text hidden-sm-only"
                          >
                          
                            <span style="font-weight: bold">{{
                              item.name
                            }}</span>
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            class="coco-list-label-text hidden-sm-only"
                          >
                         
                            <span style="font-weight: bold">{{
                              item.name
                            }}</span>
                          </v-flex>

                        </v-layout> -->
                      </v-flex>
                      <!-- <v-layout row wrap>
                          <v-flex lg7 md7 sm7 xs5 v-if="item.empType == 0">
                            <span
                              class="hidden-sm-only"
                              style="color: #b5b5b5; font-weight: 400"
                              >{{ $t("Salary") }}:
                            </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.empType == 0">
                            <span style="color: green">{{
                              thousandSep(item.salary)
                            }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.empType == 1">
                            <span
                              class="hidden-sm-only"
                              style="color: #b5b5b5; fontweight: 400"
                            >
                              {{ $t("Perday") }}:
                            </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.empType == 1">
                            <span style="color: green">{{
                              isEmpty(item.perDay)
                                ? item.perDay.toFixed()
                                : "Perday"
                            }}</span>
                          </v-flex>

                          <v-flex lg7 md7 sm7 xs5 v-if="item.empType == 2">
                            <span
                              class="hidden-sm-only"
                              style="color: #b5b5b5; fontweight: 400"
                              >{{ $t("Perhour") }}:
                            </span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7 v-if="item.empType == 2">
                            <span style="color: green"
                              >{{
                                isEmpty(item.perHour)
                                  ? item.perHour.toFixed()
                                  : "Perhour"
                              }}
                            </span>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="
                              item.incomeCraft != 0 && item.incomeCraft != null
                            "
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5"
                              >ค่าฝีมือ :
                            </span>
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="
                              item.incomeCraft != 0 && item.incomeCraft != null
                            "
                          >
                            <span style="color: green">{{
                              isEmpty(item.incomeCraft)
                                ? thousandSep(item.incomeCraft)
                                : "totaldeduct"
                            }}</span>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="
                              item.incomePosition != 0 &&
                              item.incomePosition != null
                            "
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5"
                              >ค่าตำแหน่ง :</span
                            >
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="
                              item.incomePosition != 0 &&
                              item.incomePosition != null
                            "
                          >
                            <span style="color: green"
                              >{{
                                isEmpty(item.incomePosition)
                                  ? thousandSep(item.incomePosition)
                                  : "totaldeduct"
                              }}
                            </span>
                          </v-flex>

                          <v-flex lg3 md3 sm3 xs12>
                          
                          </v-flex>
                        </v-layout> -->
                      <!-- <v-layout row wrap>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="item.totalOT != 0 && item.totalot != null"
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5"
                              >ชม.OT:</span
                            >
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="item.totalOT != 0 && item.totalot != null"
                          >
                            <span style="color: green">{{
                              isEmpty(item.totalOT)
                                ? thousandSep(item.totalOT)
                                : "totalOT"
                            }}</span>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="
                              item.totalOTEvent != 0 &&
                              item.totalOTEvent != null
                            "
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5">
                              เงินOT :
                            </span>
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="
                              item.totalOTEvent != 0 &&
                              item.totalOTEvent != null
                            "
                          >
                            <span style="color: green">{{
                              isEmpty(item.totalOTEvent)
                                ? thousandSep(item.totalOTEvent)
                                : "totalOTEvent"
                            }}</span>
                          </v-flex>

                          <v-flex xs12>
                            <v-layout
                              row
                              warp
                              v-for="(items, j) in table_datalist_resign[i]
                                .incomeAndExpenses"
                              :key="j"
                            >
                              <v-flex
                                lg7
                                md7
                                sm7
                                xs5
                                v-if="items.tranFlag == 0"
                              >
                                <span
                                  class="hidden-sm-only"
                                  style="color: #b5b5b5"
                                >
                                  {{ items.name }} :</span
                                >
                              </v-flex>
                              <v-flex
                                lg7
                                md7
                                sm7
                                xs7
                                v-if="items.tranFlag == 0"
                              >
                                <span
                                  class="hidden-sm-only"
                                  style="color: green"
                                  >{{
                                    isEmpty(items.amount)
                                      ? thousandSep(items.amount)
                                      : "amount"
                                  }}</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs5>
                            <span style="color: #b5b5b5">{{
                              $t("Totalincome") + ":"
                            }}</span>
                          </v-flex>
                          <v-flex lg7 md7 sm7 xs7>
                            <span style="color: green">{{
                              thousandSep(item.totalEarning)
                            }}</span>
                          </v-flex>
                        </v-layout> -->
                      <!-- <v-layout row wrap>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="
                              item.totalAbsent != '0' &&
                              item.totalAbsent != null
                            "
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5"
                              >ชม ขาดงาน :
                            </span>
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="
                              item.totalAbsent != '0' &&
                              item.totalAbsent != null
                            "
                          >
                            <span style="color: red">{{
                              isEmpty(item.totalAbsent)
                                ? thousandSep(item.totalAbsent)
                                : "totalAbsent"
                            }}</span>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="
                              item.deductAbsent != '0' &&
                              item.deductAbsent != null
                            "
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5"
                              >หักเงินขาด:
                            </span>
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="
                              item.deductAbsent != '0' &&
                              item.deductAbsent != null
                            "
                          >
                            <span style="color: red">{{
                              isEmpty(item.deductAbsent)
                                ? thousandSep(item.deductAbsent)
                                : "deductAbsent"
                            }}</span>
                          </v-flex>

                          <v-flex xs12>
                            <v-layout
                              row
                              warp
                              v-for="(items, j) in table_datalist_resign[i]
                                .incomeAndExpenses"
                              :key="j"
                            >
                              <v-flex
                                lg7
                                md7
                                sm7
                                xs5
                                v-if="items.tranFlag == 1"
                              >
                                <span
                                  class="coco-list-label-text hidden-sm-only"
                                  style="color: #b5b5b5"
                                >
                                  {{ items.name }} :</span
                                >
                              </v-flex>
                              <v-flex
                                lg7
                                md7
                                sm7
                                xs7
                                v-if="items.tranFlag == 1"
                              >
                                <span
                                  class="hidden-sm-only"
                                  style="color: red"
                                  >{{
                                    isEmpty(items.amount)
                                      ? thousandSep(items.amount)
                                      : "amount"
                                  }}</span
                                >
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="item.deductSS != '0' && item.deductSS != null"
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5"
                              >{{ $t("SocialSecurity") }} :
                            </span>
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="item.deductSS != '0' && item.deductSS != null"
                          >
                            <span style="color: red">{{
                              isEmpty(item.deductSS)
                                ? thousandSep(item.deductSS)
                                : ""
                            }}</span>
                          </v-flex>

                          <v-flex
                            lg7
                            md7
                            sm7
                            xs5
                            v-if="
                              item.deductTax != '0' && item.deductTax != null
                            "
                          >
                            <span class="hidden-sm-only" style="color: #b5b5b5">
                              {{ $t("Tax") + ":" }}</span
                            >
                          </v-flex>
                          <v-flex
                            lg7
                            md7
                            sm7
                            xs7
                            v-if="
                              item.deductTax != '0' && item.deductTax != null
                            "
                          >
                            <span style="color: red">
                              {{
                                isEmpty(item.deductTax)
                                  ? thousandSep(item.deductTax)
                                  : "totaldeduct"
                              }}</span
                            >
                          </v-flex>

                          <v-flex lg3 md3 sm3 xs5>
                            <span style="color: #b5b5b5">{{
                              $t("Totalexpenses") + ":"
                            }}</span>
                          </v-flex>
                          <v-flex lg3 md3 sm3 xs7>
                            <span style="color: red">{{
                              thousandSep(item.totalDeduct)
                            }}</span>
                          </v-flex>
                        </v-layout> -->
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-chip style="margin-left: 20px; float: right" class="ma-2" color="error" text-color="white" @click="dialog = true">
                        <span style="font-size: 16px" @click="editdialog(item)">{{ $t("edit") }}</span>
                      </v-chip>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
              <v-flex md12 sm12 xs12 class="hidden-xs-only content">
                <v-expansion-panel expand>
                  <v-expansion-panel-content style="background-color: #ffffff">
                    <div slot="header">
                      <v-card class="coco-box-shadow">
                        <v-layout align-center justify-center row fill-height wrap>
                          <v-flex lg10 md9 sm8 xs6>
                            <v-layout row wrap>
                              <v-flex lg12 md12 sm12 xs12 class="hidden-xs-only content">
                                <span class="coco-list-label-text content">{{ item.code }} :</span>
                                <span>{{ item.name }}</span>
                                <span style="margin-left: 10px; font-weight: bold">{{ item.department }}</span>
                              </v-flex>

                              <v-flex lg12 md12 sm12 xs12 class="hidden-sm-and-up">
                                <span class="coco-list-label-text content">{{ item.code }}:</span>
                                <br />
                                <span>{{ item.name }}</span>

                                <span style="margin-left: 10px; font-weight: bold">{{ item.department }} &nbsp;</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex lg2 md2 sm2 xs3 text-xs-right>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <span>
                                  <strong>
                                    <h3 v-bind:style="[item.year_leave != null ? { color: 'green' } : { color: 'red' }]">
                                      {{ item.year_leave != null ? "ปี " + item.year_leave : "ไม่ได้ระบุปีการลา" }}
                                    </h3>
                                  </strong>
                                </span>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </div>
                    <v-card-text class="coco-box-shadow" style="margin-left: 70px">
                      <!-- detail hidden-xs-only content-->

                      <table>
                        <thead>
                          <tr>
                            <th nowrap width="20%" style="text-align: left">
                              ประเภทการลา
                            </th>
                            <th nowrap width="15%" style="text-align: center">
                              สิทธิ์การลา/ชม
                            </th>
                            <th nowrap width="15%" style="text-align: center">
                              จำนวนที่ใช้/ชม
                            </th>
                            <th nowrap width="15%" style="text-align: center">
                              ลาคงเหลือ/ชม
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <span>{{ $t("Personalleave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.personal_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.personal_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.personal_leave_hour - item.personal_leave_use }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>{{ $t("Ordinationleave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.ordination_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.ordination_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.ordination_leave_hour - item.ordination_leave_use }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>{{ $t("Vacationleave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.vacation_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.vacation_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.vacation_leave_hour - item.vacation_leave_use }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>{{ $t("Maternityleave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.maternity_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.maternity_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.maternity_leave_hour - item.maternity_leave_use }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>{{ $t("Sickleave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.sick_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.sick_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.sick_leave_hour - item.sick_leave_use }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>{{ $t("MilitaryServiceLeave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.military_service_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.military_service_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.military_service_leave_hour - item.military_service_leave_use }}</span>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <span>{{ $t("Otherleave") }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: green">{{ item.other_leave_hour }}</span>
                            </td>
                            <td style="text-align: center">
                              <span>{{ item.other_leave_use }}</span>
                            </td>
                            <td style="text-align: center">
                              <span style="color: red">{{ item.other_leave_hour - item.other_leave_use }}</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>

                      <v-chip style="margin-left: 20px; float: right" class="ma-2" color="error" text-color="white" @click="dialog = true">
                        <span style="font-size: 16px" @click="editdialog(item)">แก้ไข</span>
                      </v-chip>
                    </v-card-actions>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="800px">
          <v-card pa-2>
            <v-card-title>
              <span class="headline">กำหนดสิทธิ์การลา</span>
            </v-card-title>
            <v-card-text style="overflow: auto">
              <v-layout row wrap>
                <v-flex lg2 md2 sm3 xs12 style="margin-top: 30px">
                  <strong style="margin-left: 5px">{{ $t("Leaveyear") }}</strong>
                </v-flex>
                <v-flex md4 sm4 xs12 pa-1>
                  <v-select required :items="items" item-text="name" item-value="name" v-model="dataedit.year_leave" @input="saveyearleave(dataedit.code, dataedit.year_leave)" />
                </v-flex>
              </v-layout>
              <table>
                <thead>
                  <tr>
                    <th nowrap width="55%" style="text-align: left">
                      ประเภทการลา
                    </th>
                    <th nowrap width="15%" style="text-align: center">
                      สิทธิ์การลา/ชม
                    </th>
                    <th nowrap width="15%" style="text-align: center">
                      จำนวนที่ใช้/ชม
                    </th>
                    <th nowrap width="15%" style="text-align: center">
                      ลาคงเหลือ/ชม
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>{{ $t("Personalleave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.personal_leave_hour"
                        :min="0"
                        @change="dataedit.personal_leave_hour = Math.max(Math.abs(dataedit.personal_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.personal_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.personal_leave_hour - dataedit.personal_leave_use }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{{ $t("Ordinationleave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.ordination_leave_hour"
                        :min="0"
                        @change="dataedit.ordination_leave_hour = Math.max(Math.abs(dataedit.ordination_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.ordination_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.ordination_leave_hour - dataedit.ordination_leave_use }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{{ $t("Vacationleave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.vacation_leave_hour"
                        :min="0"
                        @change="dataedit.vacation_leave_hour = Math.max(Math.abs(dataedit.vacation_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.vacation_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.vacation_leave_hour - dataedit.vacation_leave_use }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{{ $t("Maternityleave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.maternity_leave_hour"
                        :min="0"
                        @change="dataedit.maternity_leave_hour = Math.max(Math.abs(dataedit.maternity_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.maternity_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.maternity_leave_hour - dataedit.maternity_leave_use }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{{ $t("Sickleave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.sick_leave_hour"
                        :min="0"
                        @change="dataedit.sick_leave_hour = Math.max(Math.abs(dataedit.sick_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.sick_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.sick_leave_hour - dataedit.sick_leave_use }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{{ $t("MilitaryServiceLeave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.military_service_leave_hour"
                        :min="0"
                        @change="dataedit.military_service_leave_hour = Math.max(Math.abs(dataedit.military_service_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.military_service_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.military_service_leave_hour - dataedit.military_service_leave_use }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{{ $t("Otherleave") }}</span>
                    </td>
                    <td>
                      <v-text-field
                        type="number"
                        v-model="dataedit.other_leave_hour"
                        :min="0"
                        @change="dataedit.other_leave_hour = Math.max(Math.abs(dataedit.other_leave_hour), 0)"
                      />
                    </td>
                    <td>
                      <span>{{ dataedit.other_leave_use }}</span>
                    </td>
                    <td>
                      <span style="color: red">{{ dataedit.other_leave_hour - dataedit.other_leave_use }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">{{ $t("close") }}</v-btn>
              <v-btn v-if="buttoncheck == 0" color="blue darken-1" flat @click="onsave()">{{ $t("save") }}</v-btn>
              <v-btn v-if="buttoncheck == 1" color="blue darken-1" flat @click="onUpdate()">{{ $t("update") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :right="'right'" :color="snack_model.type">
          {{ snack_model.msg }}
          <v-btn dark flat icon @click="snack_model.status = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>
      </v-layout>
    </v-flex>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import MasterService from "@/services/MasterService";
import SettingService from "@/services/SettingService";
export default {
  data: () => ({
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    dialog: false,
    buttoncheck: 0,
    years_items: [],
    form_dialog: {
      code: "",
      year_leave: "",
      personal_leave_hour: 0.0,
      sick_leave_hour: 0.0,
      vacation_leave_hour: 0.0,
      ordination_leave_hour: 0.0,
      maternity_leave_hour: 0.0,
      military_service_leave_hour: 0.0,
      other_leave_hour: 0.0,
      company_id: localStorage._company_guid,
    },
    datamaster: [
      // {
      //   code: "EMP-1234",
      //   year_leave: "2021",
      //   personal_leave_hour: 20.0,
      //   sick_leave_hour: 20.0,
      //   vacation_leave_hour: 20.0,
      //   ordination_leave_hour: 20.0,
      //   maternity_leave_hour: 20.0,
      //   military_service_leave_hour: 20.0,
      //   other_leave_hour: 20.0,
      // },
      // {
      //   code: "EMP-1233",
      //   year_leave: "2021",
      //   personal_leave_hour: 20.0,
      //   sick_leave_hour: 15.0,
      //   vacation_leave_hour: 10.0,
      //   ordination_leave_hour: 30.0,
      //   maternity_leave_hour: 10.0,
      //   military_service_leave_hour: 20.0,
      //   other_leave_hour: 20.0,
      // },
    ],
    datause: {
      personal_leave_use: 0.0,
      sick_leave_use: 0.0,
      vacation_leave_use: 0.0,
      ordination_leave_use: 0.0,
      maternity_leave_use: 0.0,
      military_service_leave_use: 0.0,
      other_leave_use: 0.0,
    },
    listleave: [],
    dataedit: {},
    items: [],
    years: "",
    branch_Select: "",
    department_Select: "",
    form_rules: {
      branch: [(v) => !!v || "do not empty."],
      number: [(v) => !!v || "do not empty."],
    },
  }),
  computed: {
    ...mapState("filter", ["Branch_List", "Department_List", "Position_List", "Errormsg", "SelectBranch", "SelectDepartment", "SelectPosition", "SelectBranch", , "SearchData"]),
    ...mapState("app", ["showLoading"]),
    branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
        await this.checkdata();
      },
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
        await this.checkdata();
      },
    },
    positionSelect: {
      get() {
        return this.SelectPosition;
      },
      async set(value) {
        await this.checkdata();
        await this.selectedPosition({ data: value });
      },
    },
  },
  mounted: function() {
    if (this.Branch_List.length == 0) {
      this.getBranch();
    }
  },
  created: function() {
    this.createyear();
    this.checkdata();
    this.years = new Date().toISOString().substr(0, 4);
    this.$store.watch(
      (state) => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {},
      {
        deep: true,
      }
    );
  },
  methods: {
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    checkdata() {
      MasterService.getEmployeeLeaveList(this.SelectBranch, this.SelectDepartment, this.SelectPosition, this.Search_data, this.pageActive).then((res) => {
        // console.log(res.data.content);
        this.datamaster = res.data.content;
        this.listleave = [];
        this.datamaster.forEach((element) => {
          if (element.year_leave != null) {
            MasterService.checkleaveList(element.code, element.year_leave).then((res) => {
              if (res.data.personal_leave_use != null) {
                this.datause.personal_leave_use = res.data.personal_leave_use;
              }
              if (res.data.sick_leave_use != null) {
                this.datause.sick_leave_use = res.data.sick_leave_use;
              }
              if (res.data.vacation_leave_use != null) {
                this.datause.vacation_leave_use = res.data.vacation_leave_use;
              }
              if (res.data.ordination_leave_use != null) {
                this.datause.ordination_leave_use = res.data.ordination_leave_use;
              }
              if (res.data.maternity_leave_use != null) {
                this.datause.maternity_leave_use = res.data.maternity_leave_use;
              }
              if (res.data.military_service_leave_use != null) {
                this.datause.military_service_leave_use = res.data.military_service_leave_use;
              }
              if (res.data.other_leave_use != null) {
                this.datause.other_leave_use = res.data.other_leave_use;
              }
              this.listleave.push({
                code: element.code,
                name: element.first_name + " " + element.last_name,
                department: element.department_name,
                year_leave: element.year_leave,
                personal_leave_hour: element.personal_leave_hour,
                personal_leave_use: this.datause.personal_leave_use,
                sick_leave_hour: element.sick_leave_hour,
                sick_leave_use: this.datause.sick_leave_use,
                vacation_leave_hour: element.vacation_leave_hour,
                vacation_leave_use: this.datause.vacation_leave_use,
                ordination_leave_hour: element.ordination_leave_hour,
                ordination_leave_use: this.datause.ordination_leave_use,
                maternity_leave_hour: element.maternity_leave_hour,
                maternity_leave_use: this.datause.maternity_leave_use,
                military_service_leave_hour: element.military_service_leave_hour,
                military_service_leave_use: this.datause.military_service_leave_use,
                other_leave_hour: element.other_leave_hour,
                other_leave_use: this.datause.other_leave_use,
              });
            });
          } else {
            this.listleave.push({
              code: element.code,
              name: element.first_name + " " + element.last_name,
              department: element.department_name,
              year_leave: element.year_leave,
              personal_leave_hour: element.personal_leave_hour,
              personal_leave_use: this.datause.personal_leave_use,
              sick_leave_hour: element.sick_leave_hour,
              sick_leave_use: this.datause.sick_leave_use,
              vacation_leave_hour: element.vacation_leave_hour,
              vacation_leave_use: this.datause.vacation_leave_use,
              ordination_leave_hour: element.ordination_leave_hour,
              ordination_leave_use: this.datause.ordination_leave_use,
              maternity_leave_hour: element.maternity_leave_hour,
              maternity_leave_use: this.datause.maternity_leave_use,
              military_service_leave_hour: element.military_service_leave_hour,
              military_service_leave_use: this.datause.military_service_leave_use,
              other_leave_hour: element.other_leave_hour,
              other_leave_use: this.datause.other_leave_use,
            });
          }

          // console.log(this.listleave);
        });
      });

      // this.datamaster.forEach((element) => {
      //   this.datause.forEach((el) => {
      //     if (element.code == el.code) {
      //       this.listleave.push({
      //         code: element.code,
      //         year_leave: element.year_leave,
      //         personal_leave_hour: element.personal_leave_hour,
      //         personal_leave_use: el.personal_leave_use,
      //         sick_leave_hour: element.sick_leave_hour,
      //         sick_leave_use: el.sick_leave_use,
      //         vacation_leave_hour: element.vacation_leave_hour,
      //         vacation_leave_use: el.vacation_leave_use,
      //         ordination_leave_hour: element.ordination_leave_hour,
      //         ordination_leave_use: el.ordination_leave_use,
      //         maternity_leave_hour: element.maternity_leave_hour,
      //         maternity_leave_use: el.maternity_leave_use,
      //         military_service_leave_hour: element.military_service_leave_hour,
      //         military_service_leave_use: el.military_service_leave_use,
      //         other_leave_hour: element.other_leave_hour,
      //         other_leave_use: el.other_leave_use,
      //       });
      //     }
      //   });
      // });
    },
    createyear() {
      var curryears = new Date().toISOString().substr(0, 4);
      var startyear = parseInt(curryears) - 5;
      var endyear = parseInt(curryears) + 5;
      console.log("curryears", curryears);
      console.log("startyear", startyear);
      console.log("endyear", endyear);
      for (var d = startyear; d <= endyear; d++) {
        this.items.push({ name: d + "" });
      }
      console.log(this.items);
    },
    async editdialog(item) {
      console.log(item);
      await MasterService.getDetailsLeaveByCode(item.code, item.year_leave).then((response) => {
        MasterService.checkleaveList(item.code, item.year_leave).then((res) => {
          console.log(response);
          console.log(res);
          if (response.data != "") {
            this.dataedit = {};
            this.dataedit.code = response.data.code;
            this.dataedit.year_leave = response.data.year_leave;
            (this.dataedit.personal_leave_hour = response.data.personal_leave_hour),
              (this.dataedit.sick_leave_hour = response.data.sick_leave_hour),
              (this.dataedit.vacation_leave_hour = response.data.vacation_leave_hour),
              (this.dataedit.ordination_leave_hour = response.data.ordination_leave_hour),
              (this.dataedit.maternity_leave_hour = response.data.maternity_leave_hour),
              (this.dataedit.military_service_leave_hour = response.data.military_service_leave_hour),
              (this.dataedit.other_leave_hour = response.data.other_leave_hour);

            if (res.data.personal_leave_use != null) {
              this.dataedit.personal_leave_use = res.data.personal_leave_use;
            } else {
              this.dataedit.personal_leave_use = 0;
            }
            if (res.data.sick_leave_use != null) {
              this.dataedit.sick_leave_use = res.data.sick_leave_use;
            } else {
              this.dataedit.sick_leave_use = 0;
            }
            if (res.data.vacation_leave_use != null) {
              this.dataedit.vacation_leave_use = res.data.vacation_leave_use;
            } else {
              this.dataedit.vacation_leave_use = 0;
            }
            if (res.data.ordination_leave_use != null) {
              this.dataedit.ordination_leave_use = res.data.ordination_leave_use;
            } else {
              this.dataedit.ordination_leave_use = 0;
            }
            if (res.data.maternity_leave_use != null) {
              this.dataedit.maternity_leave_use = res.data.maternity_leave_use;
            } else {
              this.dataedit.maternity_leave_use = 0;
            }
            if (res.data.military_service_leave_use != null) {
              this.dataedit.military_service_leave_use = res.data.military_service_leave_use;
            } else {
              this.dataedit.military_service_leave_use = 0;
            }
            if (res.data.other_leave_use != null) {
              this.dataedit.other_leave_use = res.data.other_leave_use;
            } else {
              this.dataedit.other_leave_use = 0;
            }
            this.buttoncheck = 1;
            console.log(this.dataedit);
          } else if (response.data == "") {
            this.dataedit = {};
            this.dataedit.code = item.code;
            this.dataedit.year_leave = new Date().toISOString().substr(0, 4);
            (this.dataedit.personal_leave_hour = 0),
              (this.dataedit.personal_leave_use = 0),
              (this.dataedit.sick_leave_hour = 0),
              (this.dataedit.sick_leave_use = 0),
              (this.dataedit.vacation_leave_hour = 0),
              (this.dataedit.vacation_leave_use = 0),
              (this.dataedit.ordination_leave_hour = 0),
              (this.dataedit.ordination_leave_use = 0),
              (this.dataedit.maternity_leave_hour = 0),
              (this.dataedit.maternity_leave_use = 0),
              (this.dataedit.military_service_leave_hour = 0),
              (this.dataedit.military_service_leave_use = 0),
              (this.dataedit.other_leave_hour = 0),
              (this.dataedit.other_leave_use = 0);
            this.buttoncheck = 0;
            console.log(this.dataedit);
          }
        });
        // console.log(res);
        // console.log(this.datamaster)
        // if(res.data!="" && res.data != undefined){
        //   console.log("เข้า");
        // }
        // else if(res.data == ""){
        //   console.log("เข้าเน้อ");
        // }
      });
      // this.dataedit.roworder = item.roworder;
      // this.dataedit.code = item.code;
      // this.dataedit.year_leave = item.year_leave;
      // (this.dataedit.personal_leave_hour = item.personal_leave_hour),
      //   (this.dataedit.personal_leave_use = item.personal_leave_use),
      //   (this.dataedit.sick_leave_hour = item.sick_leave_hour),
      //   (this.dataedit.sick_leave_use = item.sick_leave_use),
      //   (this.dataedit.vacation_leave_hour = item.vacation_leave_hour),
      //   (this.dataedit.vacation_leave_use = item.vacation_leave_use),
      //   (this.dataedit.ordination_leave_hour = item.ordination_leave_hour),
      //   (this.dataedit.ordination_leave_use = item.ordination_leave_use),
      //   (this.dataedit.maternity_leave_hour = item.maternity_leave_hour),
      //   (this.dataedit.maternity_leave_use = item.maternity_leave_use),
      //   (this.dataedit.military_service_leave_hour =
      //     item.military_service_leave_hour),
      //   (this.dataedit.military_service_leave_use =
      //     item.military_service_leave_use),
      //   (this.dataedit.other_leave_hour = item.other_leave_hour),
      //   (this.dataedit.other_leave_use = item.other_leave_use);
      //   console.log(this.dataedit)
      this.dialog = true;
    },
    selectbranch() {
      let v = this;
      setTimeout(function() {
        if (this.branchSelect != "ALL" && this.departmentSelect == "ALL" && this.SelectPosition == "ALL") {
          v.$emit("set");
        } else if (this.branchSelect != "ALL" && this.departmentSelect != "ALL" && this.SelectPosition == "ALL") {
          v.$emit("set");
        } else if (this.branchSelect != "ALL" && this.departmentSelect != "ALL" && this.SelectPosition != "ALL") {
          v.$emit("set");
        } else {
          v.$emit("set");
        }
      }, 100);
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      SettingService.getProfileDepartmentList()
        .then((res) => {
          this.department_items = res.data.content;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onsave() {
      (this.form_dialog.code = this.dataedit.code), (this.form_dialog.year_leave = this.dataedit.year_leave);
      (this.form_dialog.personal_leave_hour = this.dataedit.personal_leave_hour),
        (this.form_dialog.sick_leave_hour = this.dataedit.sick_leave_hour),
        (this.form_dialog.vacation_leave_hour = this.dataedit.vacation_leave_hour),
        (this.form_dialog.ordination_leave_hour = this.dataedit.ordination_leave_hour),
        (this.form_dialog.maternity_leave_hour = this.dataedit.maternity_leave_hour),
        (this.form_dialog.military_service_leave_hour = this.dataedit.military_service_leave_hour),
        (this.form_dialog.other_leave_hour = this.dataedit.other_leave_hour);
      this.form_dialog.company_id = localStorage._company_guid;
      MasterService.createLeaveYear(this.form_dialog)
        .then((res) => {
          this.dialog = false;
          this.snack_model.status = true;
          this.snack_model.msg = "บันทึกสำเร็จ";
          this.snack_model.type = "success";
          this.checkdata();
        })
        .catch({});
      console.log(this.form_dialog);
    },
    async onUpdate() {
      await MasterService.getDetailsLeaveByCode(this.dataedit.code, this.dataedit.year_leave).then((res) => {
        console.log(res);
        this.form_dialog.roworder = res.data.roworder;
      });
      this.form_dialog.code = this.dataedit.code;
      this.form_dialog.year_leave = this.dataedit.year_leave;
      this.form_dialog.personal_leave_hour = this.dataedit.personal_leave_hour;
      this.form_dialog.sick_leave_hour = this.dataedit.sick_leave_hour;
      this.form_dialog.vacation_leave_hour = this.dataedit.vacation_leave_hour;
      this.form_dialog.ordination_leave_hour = this.dataedit.ordination_leave_hour;
      this.form_dialog.maternity_leave_hour = this.dataedit.maternity_leave_hour;
      this.form_dialog.military_service_leave_hour = this.dataedit.military_service_leave_hour;
      this.form_dialog.other_leave_hour = this.dataedit.other_leave_hour;
      this.form_dialog.company_id = localStorage._company_guid;
      console.log(this.form_dialog);
      MasterService.updateLeaveYear(this.form_dialog)
        .then((res) => {
          this.dialog = false;
          this.checkdata();
          this.snack_model.status = true;
          this.snack_model.msg = "บันทึกสำเร็จ";
          this.snack_model.type = "success";
        })
        .catch({});
      console.log(this.form_dialog);
    },
    async saveyearleave(code, date) {
      this.leave_details = [];
      await MasterService.getDetailsLeaveByCode(code, date).then((response) => {
        MasterService.checkleaveList(code, date).then((res) => {
          console.log(response);
          console.log(res);
          if (response.data != "") {
            this.dataedit = {};
            this.dataedit.code = response.data.code;
            this.dataedit.year_leave = response.data.year_leave;
            (this.dataedit.personal_leave_hour = response.data.personal_leave_hour),
              (this.dataedit.sick_leave_hour = response.data.sick_leave_hour),
              (this.dataedit.vacation_leave_hour = response.data.vacation_leave_hour),
              (this.dataedit.ordination_leave_hour = response.data.ordination_leave_hour),
              (this.dataedit.maternity_leave_hour = response.data.maternity_leave_hour),
              (this.dataedit.military_service_leave_hour = response.data.military_service_leave_hour),
              (this.dataedit.other_leave_hour = response.data.other_leave_hour);

            if (res.data.personal_leave_use != null) {
              this.dataedit.personal_leave_use = res.data.personal_leave_use;
            } else {
              this.dataedit.personal_leave_use = 0;
            }
            if (res.data.sick_leave_use != null) {
              this.dataedit.sick_leave_use = res.data.sick_leave_use;
            } else {
              this.dataedit.sick_leave_use = 0;
            }
            if (res.data.vacation_leave_use != null) {
              this.dataedit.vacation_leave_use = res.data.vacation_leave_use;
            } else {
              this.dataedit.vacation_leave_use = 0;
            }
            if (res.data.ordination_leave_use != null) {
              this.dataedit.ordination_leave_use = res.data.ordination_leave_use;
            } else {
              this.dataedit.ordination_leave_use = 0;
            }
            if (res.data.maternity_leave_use != null) {
              this.dataedit.maternity_leave_use = res.data.maternity_leave_use;
            } else {
              this.dataedit.maternity_leave_use = 0;
            }
            if (res.data.military_service_leave_use != null) {
              this.dataedit.military_service_leave_use = res.data.military_service_leave_use;
            } else {
              this.dataedit.military_service_leave_use = 0;
            }
            if (res.data.other_leave_use != null) {
              this.dataedit.other_leave_use = res.data.other_leave_use;
            } else {
              this.dataedit.other_leave_use = 0;
            }
            // this.dataedit.sick_leave_use = res.data.sick_leave_use,
            // this.dataedit.vacation_leave_use = res.data.vacation_leave_use,
            // this.dataedit.ordination_leave_use =res.data.ordination_leave_use,
            // this.dataedit.maternity_leave_use = res.data.maternity_leave_use,
            // this.dataedit.military_service_leave_use = res.data.military_service_leave_use,
            // this.dataedit.other_leave_use = res.data.other_leave_use;
            console.log(this.dataedit);
            this.buttoncheck = 1;
          } else if (response.data == "") {
            this.dataedit = {};
            this.dataedit.code = code;
            this.dataedit.year_leave = date;
            (this.dataedit.personal_leave_hour = 0),
              (this.dataedit.personal_leave_use = 0),
              (this.dataedit.sick_leave_hour = 0),
              (this.dataedit.sick_leave_use = 0),
              (this.dataedit.vacation_leave_hour = 0),
              (this.dataedit.vacation_leave_use = 0),
              (this.dataedit.ordination_leave_hour = 0),
              (this.dataedit.ordination_leave_use = 0),
              (this.dataedit.maternity_leave_hour = 0),
              (this.dataedit.maternity_leave_use = 0),
              (this.dataedit.military_service_leave_hour = 0),
              (this.dataedit.military_service_leave_use = 0),
              (this.dataedit.other_leave_hour = 0),
              (this.dataedit.other_leave_use = 0);
            console.log(this.dataedit);
            this.buttoncheck = 0;
          }
        });
        // console.log(res);
        // console.log(this.datamaster)
        // if(res.data!="" && res.data != undefined){
        //   console.log("เข้า");
        // }
        // else if(res.data == ""){
        //   console.log("เข้าเน้อ");
        // }
      });
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
h3,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.v-card__text {
  padding: 16px !important;
}

.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1020px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
@media only screen and (min-device-width: 772px) and (max-device-width: 1020px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>
